import { render } from "./ReactionByButton.vue?vue&type=template&id=4379c9f3"
import script from "./ReactionByButton.vue?vue&type=script&lang=js"
export * from "./ReactionByButton.vue?vue&type=script&lang=js"
script.render = render

export default script